import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer",
	enableBackground: "new 0 0 64 64",
	height: "512px",
	viewBox: "0 0 64 64",
	width: "512px",
	className: "",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m41 8c-4.009 0-7.775 1.562-10.604 4.396l-5 5c-.781.781-.781 2.047 0 2.828s2.047.781 2.828 0l5.001-5.001c2.075-2.078 4.836-3.223 7.775-3.223s5.7 1.145 7.777 3.225c2.078 2.075 3.223 4.836 3.223 7.775s-1.145 5.7-3.224 7.776l-5 5c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586l4.999-4.999c2.835-2.83 4.397-6.596 4.397-10.605s-1.562-7.775-4.395-10.604c-2.83-2.834-6.596-4.396-10.605-4.396z",
			className: "active-path",
			fill: "#2AA3BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m35.776 43.776-5.001 5.001c-2.075 2.078-4.836 3.223-7.775 3.223s-5.7-1.145-7.779-3.227c-2.077-2.069-3.221-4.83-3.221-7.773s1.144-5.704 3.224-7.776l5-5c.781-.781.781-2.047 0-2.828s-2.047-.781-2.828 0l-4.997 4.997c-2.837 2.825-4.399 6.592-4.399 10.607s1.562 7.782 4.395 10.604c2.83 2.834 6.596 4.396 10.605 4.396s7.775-1.562 10.604-4.396l5-5c.781-.781.781-2.047 0-2.828s-2.046-.781-2.828 0z",
			className: "active-path",
			fill: "#2AA3BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m39.242 24.758c-1.133-1.134-2.639-1.758-4.242-1.758s-3.109.624-4.242 1.758l-6 5.999c-1.134 1.134-1.758 2.64-1.758 4.243s.624 3.109 1.757 4.242c1.134 1.134 2.64 1.758 4.243 1.758s3.109-.624 4.242-1.758l6-5.999c1.134-1.134 1.758-2.64 1.758-4.243s-.624-3.109-1.758-4.242zm-2.828 5.656-6.001 6c-.754.756-2.071.757-2.827-.001-.378-.377-.586-.879-.586-1.413s.208-1.036.586-1.414l6.001-6c.377-.378.879-.586 1.413-.586s1.036.208 1.413.586c.001 0 .001 0 .001.001.378.377.586.879.586 1.413s-.208 1.036-.586 1.414z",
			className: "active-path",
			fill: "#2AA3BB"
		})
	] })
});
export default SvgLink;
